<script setup>
import { computed, toRefs } from 'vue';
import BlogCard from './Card.vue';

const props = defineProps({
  relatedBlogs: {
    type: Array,
    required: true,
    default: () => [],
  },
  routePath: {
    type: String,
    required: true,
    default: '/blogs-and-insights',
  },
});

const { relatedBlogs, routePath } = toRefs(props);

// Take up to 3 blogs directly, assuming backend provides relevant ones
const filteredRelatedBlogs = computed(() => {
  if (!relatedBlogs.value || relatedBlogs.value.length === 0) {
    console.log('No related blogs available');
    return [];
  }
  // Ensure valid blogs and take top 3
  return relatedBlogs.value
    .filter(blog => blog.id && blog.slug && blog.title && blog.tags && blog.featuredImage)
    .slice(0, 3);
});
</script>

<template>
  <div v-if="filteredRelatedBlogs.length > 0" class="related-resources">
    <h2 class="section-title">Related <span class="color">Resources</span></h2>
    <v-row class="card-container">
      <v-col
        v-for="blog in filteredRelatedBlogs"
        :key="blog.id"
        cols="12"
        sm="6"
        md="6"
        lg="4"
      >
        <BlogCard :item="blog" :routePath="routePath" />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.related-resources {
  margin: 0 auto;
  padding: 4rem 2rem;
  background-color: #f9f9f9;
}
.color {
  color: var(--accent-red);
}
.section-title {
  font-size: clamp(24px, 5vw, 32px);
  font-weight: bold;
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
}

.card-container {
  max-width: 1280px;
  margin: 0 auto;
}

@media (max-width: 460px) {
 .related-resources {
    margin: 0 auto;
    padding: 4rem 1rem;
    background-color: #f9f9f9;
  }
}
</style>